// constants
import { FaultyActionTypes } from './constants';

export type FaultyActionType = {
    type:
        | FaultyActionTypes.API_RESPONSE_SUCCESS
        | FaultyActionTypes.API_RESPONSE_ERROR
        | FaultyActionTypes.RESET
        | FaultyActionTypes.UPD_FAULTY_SENT
        | FaultyActionTypes.UPD_FAULTY_DECLARE
        | FaultyActionTypes.ADD_FAULTY_SENT
        | FaultyActionTypes.ADD_FAULTY_DECLARE
        | FaultyActionTypes.UPD_FAULTY_RECEIVED
        | FaultyActionTypes.ADD_FAULTY_RECEIVED
        | FaultyActionTypes.UPD_FAULTY_RECEIVED_BACK
        | FaultyActionTypes.ADD_FAULTY_RECEIVED_BACK;
    payload: {} | string;
};

type InvoiceData = {
    name: string;
};

// common success
export const faultyApiResponseSuccess = (actionType: string, data: InvoiceData | {}): FaultyActionType => ({
    type: FaultyActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const faultyApiResponseError = (actionType: string, error: string): FaultyActionType => ({
    type: FaultyActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const addFaultyReceived = (
    entrydate:String,
    accountid:String,
    sales_categoriesid:String,
    reference:String,
    notes:String,
    totalprice:String,
    cashpaid:String,
    subtotal:String,
    netamount:String,
    invoicedetdata: Object
): FaultyActionType => ({
    type: FaultyActionTypes.ADD_FAULTY_RECEIVED,
    payload: {
        entrydate,
        accountid,
        sales_categoriesid,
        reference,
        notes,
        totalprice,
        cashpaid,
        subtotal,
        netamount,
        invoicedetdata,
    },
});
export const addFaultySent = (
    entrydate:String,
    accountid:String,
    sales_categoriesid:String,
    reference:String,
    notes:String,
    totalprice:String,
    cashpaid:String,
    subtotal:String,
    netamount:String,
    invoicedetdata: Object
): FaultyActionType => ({
    type: FaultyActionTypes.ADD_FAULTY_SENT,
    payload: {
        entrydate,
        accountid,
        sales_categoriesid,
        reference,
        notes,
        totalprice,
        cashpaid,
        subtotal,
        netamount,
        invoicedetdata,
    },
});
export const addFaultyDeclare = (
    entrydate:String,
    notes:String,
    invoicedetdata: Object
): FaultyActionType => ({
    type: FaultyActionTypes.ADD_FAULTY_DECLARE,
    payload: {
        entrydate,
        notes,
        invoicedetdata,
    },
});
export const editFaultyDeclare = (
    id: string,
    entrydate:String,
    notes:String,
    invoicedetdata: Object
): FaultyActionType => ({
    type: FaultyActionTypes.UPD_FAULTY_DECLARE,
    payload: {
        id,
        entrydate,
        notes,
        invoicedetdata,
    },
});
export const editFaultySent = (
    id: string,
    entrydate:String,
    accountid:String,
    sales_categoriesid:String,
    reference:String,
    notes:String,
    totalprice:String,
    cashpaid:String,
    subtotal:String,
    netamount:String,
    invoicedetdata: Object
): FaultyActionType => ({
    type: FaultyActionTypes.UPD_FAULTY_SENT,
    payload: {
        id,
        entrydate,
        accountid,
        sales_categoriesid,
        reference,
        notes,
        totalprice,
        cashpaid,
        subtotal,
        netamount,
        invoicedetdata,
    },
});
export const editFaultyReceivedBack = (
    id: string,
    entrydate:String,
    accountid:String,
    sales_categoriesid:String,
    reference:String,
    notes:String,
    totalprice:String,
    cashpaid:String,
    subtotal:String,
    netamount:String,
    invoicedetdata: Object
): FaultyActionType => ({
    type: FaultyActionTypes.UPD_FAULTY_RECEIVED_BACK,
    payload: {
        id,
        entrydate,
        accountid,
        sales_categoriesid,
        reference,
        notes,
        totalprice,
        cashpaid,
        subtotal,
        netamount,
        invoicedetdata,
    },
});
export const addFaultyReceivedBack = (
    entrydate:String,
    accountid:String,
    sales_categoriesid:String,
    reference:String,
    notes:String,
    totalprice:String,
    cashpaid:String,
    subtotal:String,
    netamount:String,
    invoicedetdata: Object
): FaultyActionType => ({
    type: FaultyActionTypes.ADD_FAULTY_RECEIVED_BACK,
    payload: {
        entrydate,
        accountid,
        sales_categoriesid,
        reference,
        notes,
        totalprice,
        cashpaid,
        subtotal,
        netamount,
        invoicedetdata,
    },
});
export const editFaultyReceived = (
    id: string,
    entrydate:String,
    accountid:String,
    sales_categoriesid:String,
    reference:String,
    notes:String,
    totalprice:String,
    cashpaid:String,
    subtotal:String,
    netamount:String,
    invoicedetdata: Object
): FaultyActionType => ({
    type: FaultyActionTypes.UPD_FAULTY_RECEIVED,
    payload: {
        id,
        entrydate,
        accountid,
        sales_categoriesid,
        reference,
        notes,
        totalprice,
        cashpaid,
        subtotal,
        netamount,
        invoicedetdata,
    },
});
export const resetFaulty = (): FaultyActionType => ({
    type: FaultyActionTypes.RESET,
    payload: {},
});
